import { Directive, Input } from '@angular/core'

@Directive({
  selector: '[jmlVar]',
  exportAs: 'jmlVar'
})
export class VarDirective {
  [key: string]: any

  @Input('jmlVar') set assign(value: any) {
    if (value) {
      Object.assign(this, value)
    }
  }
}
